<template>
  <div class="app-check-sim-card">
    <div class="modal fade install-info-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title"></h2>
            <button type="button" aria-label="Close" data-dismiss="modal" class="close">×</button>
          </div>
          <div class="modal-body">
            <div>
              <slot name="mdlTextSingle"><strong>1.Single-SIM-Modell:</strong> Überprüfe, ob dein Smartphone Empfang hat. Wenn ja, dann wurde Einrichtung erfolgreich durchgeführt.</slot>
            </div>
            <br>
            <div>
              <slot name="mdlTextDual"><strong>2.Dual-SIM-Modelle:</strong> Überprüfe, ob beide SIM- Karten in der Netzanzeige angezeigt werden. Wenn ja, dann wurde Einrichtung erfolgreich durchgeführt.</slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="header">
      <h1>Meine LIDL Connect SIM</h1>
      <p>Hier kannst du den Status deiner SIM-Karte prüfen und deine PUK einsehen.
        Den PUK (Super PIN) benötigst Du zum Beispiel wenn deine SIM durch mehrmalige Falscheingaben deines PINS gesperrt wurde.
        Bitte stelle sicher, dass niemand die angezeigten Daten mitlesen kann.</p>
    </slot>
    <b-row class="sim-type">
      <b-col class="label">
        <slot name="lblSimType"> SIM-Type:</slot>
      </b-col>
      <b-col class="value">{{ simTypeLabel  }}</b-col>
    </b-row>
    <b-row class="msisdn">
      <b-col class="label">
        <slot name="lblMsisdn"> Rufnummer</slot>
      </b-col>
      <b-col class="value">{{ msisdn }}</b-col>
    </b-row>
    <b-row class="status">
      <b-col class="label">
        <slot v-if="isTypeSimCard" name="lblStatus"> SIM-Kartenstatus:</slot>
        <slot v-if="isTypeESim" name="lblESimStatus"> eSIM-Status:</slot>
      </b-col>
      <b-col class="value">{{ status }}</b-col>
    </b-row>
    <b-row class="icc-id">
      <b-col class="label">
        <slot v-if="isTypeSimCard" name="lblIccId'">SIM-Kartenseriennummer:</slot>
        <slot v-if="isTypeESim" name="lblESimSerialNumber'">eSIM-Seriennummer:</slot>
      </b-col>
      <b-col class="value">{{ iccId }}</b-col>
    </b-row>
    <b-row class="puk">
      <b-col class="label">
        <slot name="lblPUK">PUK (Super PIN):</slot>
      </b-col>
      <b-col class="value">{{ pukView }}</b-col>
    </b-row>
    <b-row class="installInfo">
      <b-col class="text">
        <slot name="lblInfo">Wie überprüfe ich, ob das eSIM Profil auf meinem Smartphone eingerichtet ist?</slot>
        <span class="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
        <span class="question-icon" data-toggle="modal" data-target=".install-info-modal"></span>
      </b-col>
    </b-row>
    <b-row class="puk-button">
      <b-col class="button">
        <b-button @click="togglePuk()" class="btn-view" type="button" variant="primary">
          <dyn-slot :slot-data="slotData">
            <slot name="btnView">PUK anzeigen</slot>
          </dyn-slot>
        </b-button>
      </b-col>
    </b-row>
    <b-row  v-if="isTypeESim && canInstallESim" class="setup-button">
      <b-col class="button">
        <b-button @click="installESim()" class="btn-view" type="button" variant="primary">
          <dyn-slot :slot-data="slotData">
            <slot name="btnInstall">eSIM Profil einrichten</slot>
          </dyn-slot>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BButton, BCol, BRow } from 'bootstrap-vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import preFilledInput from '@/mixins/preFilledInput'
import DynSlot from '@/components/generic/DynSlot.vue'
import transaction from '@/mixins/transaction'
import { SimTypes } from '@/helper/SimTypes'

export default {
  name: 'ViewCheckSimCard',
  components: { 'b-row': BRow, 'b-col': BCol, 'b-button': BButton, DynSlot },
  mixins: [
    transaction('checkSIMCard'),
    preFilledInput('pukView', 'mask')
  ],
  data: function () {
    return {
      currentCustomer: null,
      SimTypes
    }
  },
  props: {
    mask: {
      type: String
    }
  },
  computed: {
    msisdn: function () {
      return this.currentCustomer?.contract?.msisdn
    },
    status: function () {
      let result = 'inaktiv'

      if (this.isTypeSimCard && this.currentCustomer?.contract?.simCard?.status === 'ACTIVE') {
        result = 'aktiv'
      } else if (this.isTypeESim && this.currentCustomer?.contract?.simCard?.status === 'ACTIVE') {
        result = 'aktiv'
      }

      return result
    },
    iccId: function () {
      let result = 'inaktiv'
      if (this.currentCustomer?.contract?.simCard?.iccId) {
        result = this.currentCustomer?.contract?.simCard?.iccId
      }
      return result
    },
    simType: function () {
      return this.currentCustomer?.contract?.simCard?.type
    },
    maskShown: function () {
      return this.pukView === this.mask
    },
    slotData: function () {
      return {
        maskShown: this.maskShown
      }
    },
    isTypeSimCard: function () {
      return this.simType === SimTypes.simCardCode
    },
    isTypeESim: function () {
      return this.simType === SimTypes.eSimCode
    },
    simTypeLabel: function () {
      return this.isTypeSimCard ? SimTypes.simCardLabel : SimTypes.eSimLabel
    },
    eSimPuk: function () {
      return this.currentCustomer?.contract?.simCard?.puk
    },
    canInstallESim: function () {
      return this.currentCustomer?.contract?.simCard?.status === 'ACTIVE'
    }
  },
  apollo: {
    allIdentMethods: function () {
      return wrapQuery(gql`query checkSIMCard {
        currentCustomer {
          contract {
            msisdn,
            simCard {
              iccId
              status
              puk
              type
            }
          }
        }
      }`, this, 'currentCustomer', {}, () => {
      })
    }
  },
  methods: {
    togglePuk: function () {
      if (this.pukView === this.mask) {
        this.pukView = this.currentCustomer?.contract?.simCard?.puk
      } else this.pukView = this.mask
    },
    installESim: function () {
      window.location.href = '/mein-lidl-connect/service/esim-profil-einrichten.html'
    }
  }
}
</script>
